import React from 'react';

function ReportTemplate() {
  let cells = ["A1:B3", "A4", "A5", "B4", "B5", "D5", "E5"];
  let values = ["#logo", "Datum:", formatDate(new Date(), "dd-mm-YYYY"),  "Vrijeme:", "#time", "dsadas", "TEST 123"];

  let data = {
      "value": "#logo",

  }
// Helper function to format date
function formatDate(date, format) {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const year = date.getFullYear();
  
  if (format === "dd-mm-YYYY") {
    return `${day}-${month}-${year}`;
  }
  return date.toDateString(); // Default fallback
}
  // Helper function to parse cell ranges
  const parseRange = (range) => {
    const [start, end] = range.split(':');
    const startRow = parseInt(start.substring(1), 10) - 1; // Convert to 0-based index
    const startCol = start.charCodeAt(0) - 65; // Convert 'A' to 0, 'B' to 1, etc.
    const endRow = end ? parseInt(end.substring(1), 10) - 1 : startRow;
    const endCol = end ? end.charCodeAt(0) - 65 : startCol;
    return { startRow, startCol, endRow, endCol };
  };

  // Generate table structure with merged cells
  const generateTableData = () => {
    const tableData = [];
    const mergedCells = new Set(); // Track merged cells to skip rendering them

    cells.forEach((cell, index) => {
      const { startRow, startCol, endRow, endCol } = parseRange(cell);
      for (let row = startRow; row <= endRow; row++) {
        tableData[row] = tableData[row] || [];
        for (let col = startCol; col <= endCol; col++) {
          if (row === startRow && col === startCol) {
            // Define the merged cell
            tableData[row][col] = {
              value: values[index],
              rowSpan: endRow - startRow + 1,
              colSpan: endCol - startCol + 1,
            };
          } else {
            // Mark merged cells for skipping
            mergedCells.add(`${row},${col}`);
          }
        }
      }
    });

    return { tableData, mergedCells };
  };

  const { tableData, mergedCells } = generateTableData();

  return (
    <div className="report-template-wrapper" style={{height: "100px"}}>
      <table style={{ borderCollapse: 'collapse', width: 'auto' }}>
        <colgroup>
          <col style={{ width: '150px' }} />
          <col style={{ width: '150px' }} />
          <col style={{ width: '150px' }} />
          <col style={{ width: '150px' }} />
          <col style={{ width: '150px' }} />
        </colgroup>
        <tbody>
          {tableData.map((row, rowIndex) => (
            <tr key={rowIndex} style={{ height: '20px' }}>
              {row.map((cell, colIndex) => {
                if (mergedCells.has(`${rowIndex},${colIndex}`)) {
                  return null; // Skip rendering merged cells
                }
                return (
                  <td
                    key={colIndex}
                    rowSpan={cell?.rowSpan || 1}
                    colSpan={cell?.colSpan || 1}
                    style={{
                      border: '1px solid black',
                      textAlign: 'center',
                      padding: '0',
                      width: '150px'
                    }}
                  >
                    {cell?.value || ''}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ReportTemplate;
